import { useEffect } from 'react';
import { getFlashcards, generateFlashcards } from '../../services/ai';

import './Ace.css';

function FlashcardGenerate({
    flashcards,
    setFlashcards,
    course_id,
    chapter,
    setActiveComponent,
    setLoading,
    loading,
    studyGuide,
    setStudyGuide,
    currentTask,
    setCurrentTask,
}) {
    const { id: chapter_id, name: chapter_name } = chapter;

    async function createMessage() {
        setActiveComponent('Flashcard');
        setLoading(true);

        try {
            // Existing cards short-circuit generation. This is also what makes
            // a timed-out generation recoverable: the server persists before
            // responding, so a retry lands here instead of generating again.
            const cached = await getFlashcards(course_id, chapter_id);
            if (cached.data.length >= 5) {
                setFlashcards(cached.data);
                setLoading(false);
                return;
            }

            const resp = await generateFlashcards(course_id, chapter_id);
            setFlashcards(resp.data);
            setLoading(false);
        } catch (err) {
            console.error(err);
            setLoading(false);
        }
    }

    useEffect(() => {
        if (chapter_name) {
            createMessage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chapter_name]);

    return (
        <button
            className="ace__AiGenerate-btn"
            disabled={loading}
            style={{ opacity: loading ? 0.5 : 1 }}
            onClick={createMessage}
        >
            {loading ? 'Loading...' : 'Generate Flashcards'}
        </button>
    );
}

export default FlashcardGenerate;
